import { css } from '@emotion/css'
import { borderRadius, breakpoint } from '../../styles'
import { mediaQueryHelper } from '../../styles/helpers'
import { getSkeletonColors } from '../../themes'

const styles = {
  card: css({
    boxSizing: 'border-box',
    display: 'flex',

    [mediaQueryHelper(breakpoint.tablet)]: {
      borderRadius: borderRadius.default,
    },
  }),
}

export default styles

export const cardTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })
